import * as types from './mutation-types.js'
import { getDeepProperty } from '@/helpers/deepObject.js'
import Intercom from '@/services/utilities/intercom'
import PendoSimplecast from '@/services/utilities/pendo'
import localStorageService from '@/services/localStorage'

const state = {
  name: null,
  noPodcasts: false
}

const actions = {
  // Everything needed globally for the app to function on a first load
  async initializeApp ({commit, state}, {to, from}) {
    let user = this.getters.user

    // Begin podcast loading.  None of this should be here, but we don't support NOT loading
    // a podcast by default
    let activePodcast = this.getters.activePodcast
    let activePodcastId = getDeepProperty(activePodcast, 'id')
    let podcastUserPermissions = null
    let toActivePodcastId = getDeepProperty(to, 'params.podcastId')

    // If we already have a podcast loaded, or whatever needs to be loaded is the same
    // as the podcast already loaded, don't do anything
    if (activePodcastId && (!toActivePodcastId || toActivePodcastId === activePodcastId)) {
      return
    }

    // We'll be doing all the logic off of toActivePodcastId
    if (!toActivePodcastId) {
      toActivePodcastId = activePodcastId
    }

    // If the podcast ID isn't set in URL, try grabbing from localStorage
    if (!toActivePodcastId) {
      let podcastIds = null

      try {
        podcastIds = localStorageService.getObject('recentPodcastIds')
      } catch (e) {}

      const recentPodcastIds = podcastIds && podcastIds[this.getters.user.id] ? podcastIds[this.getters.user.id] : null
      toActivePodcastId = recentPodcastIds && recentPodcastIds.length ? recentPodcastIds[0] : null
    }

    // If no toActivePodcastId yet, load a default podcast
    if (!toActivePodcastId) {
      toActivePodcastId = getDeepProperty(user, 'podcasts.default.id')
    }

    // This may or may not actually load the activePodcast, but the beforeEach in the router will handle that
    activePodcast = await this.dispatch('setActivePodcast', {userId: this.getters.user.id, podcastId: toActivePodcastId})

    // Load the permissions that a user has for the podcast
    if (getDeepProperty(activePodcast, 'id')) {
      podcastUserPermissions = await this.dispatch('getPodcastUserPermissions', this.getters.user.id)
    } else {
      commit(types.SET_NO_PODCASTS, true)
    }

    if (!from.name) {
      Intercom.bootChat(this._vm.$intercom, user, activePodcast, podcastUserPermissions)
    } else {
      Intercom.updateChat(this._vm.$intercom, user, activePodcast, podcastUserPermissions)
    }

    let podcastIds = null
    try {
      podcastIds = localStorageService.getObject('recentPodcastIds')
    } catch (e) {}
    let recentPodcastIds = podcastIds && podcastIds[this.getters.user.id] ? podcastIds[this.getters.user.id] : null

    // I really need this in the dropdown, but not moving for now
    this.dispatch('setRecentPodcastIds', {userId: this.getters.user.id, recentPodcastIds})
    await this.dispatch('getRecentPodcasts', this.getters.user.id)

    const currentAccountId = getDeepProperty(activePodcast, 'account.id')
    const accounts = this.getters.accounts
    let currentAccount = accounts.find((account) => account.id === currentAccountId)
    if (!currentAccount) {
      currentAccount = this.getters.defaultAccount
    }
    const podcastCount = this.getters.podcastCount

    // eslint-disable-next-line no-undef
    if (typeof pendo !== 'undefined') {
      PendoSimplecast.setup(pendo, user, currentAccount, activePodcast, podcastCount)
    }
  },
  saveRouteName ({commit}, name) {
    // Don't deeplink into episode pages or episode creation
    if (/episode/.test(name)) {
      name = 'episodes'
    }
    commit(types.SET_APP_ROUTE, name)
  }
}

const mutations = {
  [types.SET_APP_ROUTE] (state, name) {
    state.name = name
  },
  [types.SET_NO_PODCASTS] (state, noPodcasts) {
    state.noPodcasts = noPodcasts
  }
}

const getters = {
  noPodcasts: state => state.noPodcasts,
  savedRouteName: state => state.name
}

export default {
  actions,
  getters,
  mutations,
  state
}
